import React, {
  useState,
  useRef,
  useEffect,
} from 'react';

import {
  FaPhone,
  FaShieldAlt,
  FaCheckCircle,
  FaArrowLeft,
  FaSyncAlt,
  FaSpinner,
} from 'react-icons/fa';

import { toast } from 'react-toastify';

import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const Login = () => {
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState([
    '',
    '',
    '',
    '',
    '',
    '',
  ]);

  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [resendIn, setResendIn] = useState(0);

  const { login } = useAuth();
  const navigate = useNavigate();

  const otpRefs = useRef([]);

  /* =====================================================
     RESEND TIMER
  ===================================================== */

  useEffect(() => {
    if (!otpSent || resendIn <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setResendIn((seconds) => seconds - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [otpSent, resendIn]);

  const otpValue = otp.join('');

  /* =====================================================
     SEND OTP
  ===================================================== */

  const sendOtp = async () => {
    if (loading) return;

    const cleanedMobile = mobile.trim();

    if (!/^[6-9]\d{9}$/.test(cleanedMobile)) {
      toast.error(
        'Enter valid 10-digit mobile number'
      );
      return;
    }

    try {
      setLoading(true);

      const res = await api.post(
        '/api/auth/request-otp',
        {
          mobile: cleanedMobile,
        }
      );

      console.log(
        'REQUEST OTP RESPONSE =>',
        res.data
      );

      if (res.data?.success) {
        toast.success(
          res.data.message ||
            'OTP sent successfully'
        );

        setOtpSent(true);
        setResendIn(30);

        setOtp([
          '',
          '',
          '',
          '',
          '',
          '',
        ]);

        setTimeout(() => {
          otpRefs.current[0]?.focus();
        }, 50);
      } else {
        toast.error(
          res.data?.message ||
            'Failed to send OTP'
        );
      }

    } catch (err) {
      console.log(
        'REQUEST OTP ERROR =>',
        err?.response?.data ||
          err?.message ||
          err
      );

      toast.error(
        err?.response?.data?.message ||
          'Failed to send OTP'
      );

    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     VERIFY OTP
     CORPORATOR ONLY
  ===================================================== */

  const verifyOtp = async () => {
    if (loading) return;

    if (!/^\d{6}$/.test(otpValue)) {
      toast.error(
        'Enter valid 6-digit OTP'
      );
      return;
    }

    const cleanedMobile =
      mobile.trim();

    if (
      !/^[6-9]\d{9}$/.test(
        cleanedMobile
      )
    ) {
      toast.error(
        'Invalid mobile number'
      );
      return;
    }

    try {
      setLoading(true);

      const res = await api.post(
        '/api/auth/verify-otp',
        {
          mobile: cleanedMobile,
          otp: otpValue,
        }
      );

      console.log(
        'VERIFY OTP RESPONSE =>',
        res.data
      );

      /* =================================================
         OTP FAILED
      ================================================= */

      if (!res.data?.success) {
        toast.error(
          res.data?.message ||
            'Invalid OTP'
        );
        return;
      }

      /* =================================================
         CORPORATOR → 2FA
      ================================================= */

      /* =================================================
   CORPORATOR → 2FA SETUP OR 2FA VERIFICATION
================================================= */

if (
  res.data.requires2FA === true &&
  res.data.role === 'ROLE_CORPORATOR'
) {

  console.log(
    'CORPORATOR AUTH RESPONSE:',
    res.data
  );

  /* ---------------------------------------------
     FIRST-TIME CORPORATOR
     → Setup Google Authenticator
  --------------------------------------------- */

  if (res.data.requires2FASetup === true) {

    console.log(
      '2FA NOT SETUP → Redirecting to Setup2FA'
    );

    navigate('/setup-2fa', {
      state: {
        mobile: cleanedMobile,
        userId: res.data.userId,
      },
    });

  }

  /* ---------------------------------------------
     EXISTING CORPORATOR
     → Enter Authenticator Code
  --------------------------------------------- */

  else {

    console.log(
      '2FA ALREADY ENABLED → Redirecting to Verify2FA'
    );

    navigate('/verify-2fa', {
      state: {
        mobile: cleanedMobile,
      },
    });

  }

  return;
}

      /* =================================================
         SAFETY CHECK
         THIS WEB APP IS CORPORATOR ONLY
      ================================================= */

      if (
        res.data.role &&
        res.data.role !==
          'ROLE_CORPORATOR'
      ) {
        toast.error(
          'This account is not a Corporator account.'
        );
        return;
      }

      /* =================================================
         JWT REQUIRED
      ================================================= */

      if (!res.data?.token) {
        toast.error(
          'Authentication token not received.'
        );
        return;
      }

      /* =================================================
         LOGIN
      ================================================= */

      await login(
        res.data.token,
        res.data.user || {
          id: res.data.userId,
          role:
            res.data.role ||
            'ROLE_CORPORATOR',
          mobile:
            cleanedMobile,
        }
      );

      setVerified(true);

      toast.success(
        'Login successful'
      );

      setTimeout(() => {
        setOtp([
          '',
          '',
          '',
          '',
          '',
          '',
        ]);

        setMobile('');

        navigate(
          '/dashboard',
          {
            replace: true,
          }
        );
      }, 1100);

    } catch (err) {
      console.log(
        'VERIFY OTP ERROR =>',
        err?.response?.data ||
          err?.message ||
          err
      );

      toast.error(
        err?.response?.data?.message ||
          'Invalid OTP'
      );

    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     OTP BOX CHANGE
  ===================================================== */

  const handleOtpChange = (
    index,
    value
  ) => {
    if (!/^\d?$/.test(value)) {
      return;
    }

    const next = [...otp];

    next[index] = value;

    setOtp(next);

    if (
      value &&
      index < 5
    ) {
      otpRefs.current[
        index + 1
      ]?.focus();
    }
  };

  /* =====================================================
     OTP KEYBOARD
  ===================================================== */

  const handleOtpKeyDown = (
    index,
    e
  ) => {
    if (
      e.key === 'Backspace' &&
      !otp[index] &&
      index > 0
    ) {
      otpRefs.current[
        index - 1
      ]?.focus();
    }

    if (
      e.key === 'Enter'
    ) {
      verifyOtp();
    }
  };

  /* =====================================================
     OTP PASTE
  ===================================================== */

  const handleOtpPaste = (e) => {
    const text =
      e.clipboardData
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 6);

    if (!text) return;

    e.preventDefault();

    setOtp(
      Array.from(
        { length: 6 },
        (_, index) =>
          text[index] || ''
      )
    );

    otpRefs.current[
      Math.min(
        text.length,
        5
      )
    ]?.focus();
  };

  /* =====================================================
     RESET TO MOBILE
  ===================================================== */

  const resetToMobile = () => {
    setOtpSent(false);

    setOtp([
      '',
      '',
      '',
      '',
      '',
      '',
    ]);

    setResendIn(0);
  };

  /* =====================================================
     UI
  ===================================================== */

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F7F4EE',
        fontFamily:
          "'Inter', system-ui, sans-serif",
        padding: '24px',
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@500;700&display=swap');

        .seal-ring {
          animation: rotate 40s linear infinite;
          transform-origin: 50% 50%;
        }

        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        @keyframes stampIn {
          0% {
            transform: scale(2.2) rotate(-8deg);
            opacity: 0;
          }

          60% {
            transform: scale(0.92) rotate(2deg);
            opacity: 1;
          }

          100% {
            transform: scale(1) rotate(0deg);
            opacity: 1;
          }
        }

        .otp-box:focus {
          outline: none;
          border-color: #C9A227 !important;
          box-shadow:
            0 0 0 3px
            rgba(201,162,39,0.18);
        }

        .cp-input:focus {
          outline: none;
          border-color: #16325C !important;
          box-shadow:
            0 0 0 3px
            rgba(22,50,92,0.10);
        }

        .cp-btn:not(:disabled):hover {
          background: #0F2545 !important;
        }

        .cp-link:hover {
          text-decoration: underline;
        }

        @media (prefers-reduced-motion: reduce) {
          .seal-ring {
            animation: none;
          }
        }
      `}</style>

      <div
        style={{
          display: 'flex',
          width: '100%',
          maxWidth: '840px',
          minHeight: '520px',
          background: '#FFFFFF',
          borderRadius: '18px',
          overflow: 'hidden',
          boxShadow:
            '0 24px 60px -20px rgba(16,35,63,0.35)',
        }}
      >

        {/* =================================================
            LEFT PANEL
        ================================================= */}

        <div
          style={{
            flex: '0 0 42%',
            background:
              'linear-gradient(160deg, #16325C 0%, #0F2545 100%)',
            position: 'relative',
            padding: '44px 36px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent:
              'space-between',
            overflow: 'hidden',
          }}
        >

          <div
            style={{
              position: 'absolute',
              inset: 0,
              backgroundImage:
                'radial-gradient(circle at 20% 15%, rgba(201,162,39,0.14), transparent 45%), radial-gradient(circle at 85% 85%, rgba(201,162,39,0.10), transparent 40%)',
            }}
          />

          <div
            style={{
              position:
                'relative',
              zIndex: 1,
            }}
          >
            <div
              style={{
                width: 40,
                height: 2,
                background:
                  '#C9A227',
                marginBottom: 18,
              }}
            />

            <p
              style={{
                color: '#C9A227',
                fontSize: 12,
                letterSpacing:
                  '0.18em',
                textTransform:
                  'uppercase',
                fontWeight: 600,
                margin: 0,
              }}
            >
              Municipal Portal
            </p>

            <h1
              style={{
                fontFamily:
                  "'Fraunces', serif",
                fontWeight: 600,
                fontSize: 32,
                lineHeight: 1.15,
                color: '#F7F4EE',
                margin:
                  '10px 0 0',
              }}
            >
              Corporator
              <br />
              Sign In
            </h1>

            <p
              style={{
                color: '#9FB0C7',
                fontSize: 14,
                lineHeight: 1.6,
                marginTop: 16,
                maxWidth: 260,
              }}
            >
              Verified access for elected
              ward representatives. Sign
              in with your registered
              mobile number.
            </p>
          </div>

          {/* SEAL */}

          <div
            style={{
              position:
                'relative',
              zIndex: 1,
              alignSelf:
                'center',
              margin:
                '18px 0',
            }}
          >
            <svg
              width="132"
              height="132"
              viewBox="0 0 132 132"
              fill="none"
            >
              <g
                className={
                  verified
                    ? ''
                    : 'seal-ring'
                }
                style={
                  verified
                    ? {
                        animation:
                          'stampIn 0.5s ease-out',
                      }
                    : {}
                }
              >
                <circle
                  cx="66"
                  cy="66"
                  r="62"
                  stroke="#C9A227"
                  strokeWidth="1.2"
                  strokeDasharray="2 6"
                  opacity="0.7"
                />

                <circle
                  cx="66"
                  cy="66"
                  r="50"
                  stroke="#C9A227"
                  strokeWidth="1"
                  opacity="0.4"
                />
              </g>

              <circle
                cx="66"
                cy="66"
                r="38"
                fill={
                  verified
                    ? '#1F7A4D'
                    : '#0F2545'
                }
                stroke="#C9A227"
                strokeWidth="1.5"
              />

              {verified ? (
                <path
                  d="M50 67 L61 78 L84 54"
                  stroke="#F7F4EE"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              ) : (
                <path
                  d="M66 40 L72 58 L91 58 L76 69 L82 87 L66 76 L50 87 L56 69 L41 58 L60 58 Z"
                  fill="#C9A227"
                  opacity="0.9"
                />
              )}
            </svg>
          </div>

          <p
            style={{
              position:
                'relative',
              zIndex: 1,
              color: '#5E7292',
              fontSize: 11.5,
              letterSpacing:
                '0.04em',
              margin: 0,
            }}
          >
            OTP-verified · Encrypted
            session
          </p>
        </div>

        {/* =================================================
            RIGHT PANEL
        ================================================= */}

        <div
          style={{
            flex: 1,
            padding:
              '48px 44px',
            display: 'flex',
            flexDirection:
              'column',
            justifyContent:
              'center',
          }}
        >

          {!verified ? (
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems:
                    'center',
                  gap: 10,
                  marginBottom: 6,
                }}
              >

                {otpSent && (
                  <button
                    onClick={
                      resetToMobile
                    }
                    aria-label="Back to mobile number"
                    className="cp-link"
                    style={{
                      background:
                        'none',
                      border: 'none',
                      cursor:
                        'pointer',
                      color:
                        '#16325C',
                      padding: 4,
                      display:
                        'flex',
                    }}
                  >
                    <FaArrowLeft
                      size={16}
                    />
                  </button>
                )}

                <h2
                  style={{
                    fontFamily:
                      "'Fraunces', serif",
                    fontSize: 22,
                    fontWeight: 600,
                    color: '#10233F',
                    margin: 0,
                  }}
                >
                  {otpSent
                    ? 'Enter the code'
                    : 'Welcome back'}
                </h2>
              </div>

              <p
                style={{
                  color: '#697386',
                  fontSize: 14,
                  marginBottom: 32,
                }}
              >
                {otpSent
                  ? `We sent a 6-digit code to +91 ${mobile}`
                  : 'Enter your registered mobile number to receive a one-time code.'}
              </p>

              {/* =================================================
                  MOBILE
              ================================================= */}

              {!otpSent ? (
                <>
                  <label
                    style={{
                      fontSize: 12.5,
                      fontWeight: 600,
                      color: '#38445C',
                      letterSpacing:
                        '0.02em',
                      marginBottom: 8,
                      display:
                        'block',
                    }}
                  >
                    Mobile number
                  </label>

                  <div
                    style={{
                      display: 'flex',
                      alignItems:
                        'center',
                      border:
                        '1.5px solid #DDE2EA',
                      borderRadius: 10,
                      overflow:
                        'hidden',
                      background:
                        '#FCFBF8',
                    }}
                  >
                    <span
                      style={{
                        display:
                          'flex',
                        alignItems:
                          'center',
                        gap: 6,
                        padding:
                          '13px 14px',
                        borderRight:
                          '1.5px solid #DDE2EA',
                        color:
                          '#38445C',
                        fontSize: 14,
                        fontWeight: 600,
                        background:
                          '#F3F1EA',
                      }}
                    >
                      <FaPhone
                        size={13}
                      />
                      +91
                    </span>

                    <input
                      className="cp-input"
                      type="tel"
                      value={mobile}
                      onChange={(e) =>
                        setMobile(
                          e.target.value
                            .replace(
                              /\D/g,
                              ''
                            )
                            .slice(
                              0,
                              10
                            )
                        )
                      }
                      placeholder="98765 43210"
                      maxLength={10}
                      disabled={loading}
                      onKeyDown={(e) =>
                        e.key ===
                          'Enter' &&
                        sendOtp()
                      }
                      style={{
                        flex: 1,
                        border:
                          'none',
                        outline:
                          'none',
                        background:
                          'transparent',
                        padding:
                          '13px 14px',
                        fontSize: 15,
                        color:
                          '#10233F',
                        letterSpacing:
                          '0.03em',
                      }}
                    />
                  </div>

                  <button
                    onClick={sendOtp}
                    disabled={
                      loading
                    }
                    className="cp-btn"
                    style={{
                      marginTop: 24,
                      width: '100%',
                      background:
                        '#16325C',
                      color:
                        '#F7F4EE',
                      border: 'none',
                      borderRadius: 10,
                      padding:
                        '13px 0',
                      fontSize: 14.5,
                      fontWeight: 600,
                      cursor:
                        loading
                          ? 'default'
                          : 'pointer',
                      display:
                        'flex',
                      alignItems:
                        'center',
                      justifyContent:
                        'center',
                      gap: 8,
                      opacity:
                        loading
                          ? 0.75
                          : 1,
                    }}
                  >
                    {loading ? (
                      <>
                        <FaSpinner
                          size={14}
                          style={{
                            animation:
                              'rotate 0.8s linear infinite',
                          }}
                        />
                        Sending code
                      </>
                    ) : (
                      'Send code'
                    )}
                  </button>

                  <p
                    style={{
                      marginTop: 20,
                      textAlign:
                        'center',
                      fontSize: 13.5,
                      color:
                        '#697386',
                    }}
                  >
                    New corporator?{' '}

                    <button
                      type="button"
                      onClick={() =>
                        navigate(
                          '/register'
                        )
                      }
                      className="cp-link"
                      style={{
                        background:
                          'none',
                        border:
                          'none',
                        padding: 0,
                        color:
                          '#16325C',
                        fontWeight:
                          600,
                        cursor:
                          'pointer',
                        fontSize:
                          13.5,
                      }}
                    >
                      Register here
                    </button>
                  </p>
                </>
              ) : (

                /* =================================================
                   OTP
                ================================================= */

                <>
                  <div
                    style={{
                      display:
                        'flex',
                      gap: 8,
                      justifyContent:
                        'space-between',
                    }}
                    onPaste={
                      handleOtpPaste
                    }
                  >
                    {otp.map(
                      (
                        digit,
                        index
                      ) => (
                        <input
                          key={index}
                          ref={(el) =>
                            (otpRefs.current[
                              index
                            ] = el)
                          }
                          className="otp-box"
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(
                              index,
                              e.target.value
                            )
                          }
                          onKeyDown={(e) =>
                            handleOtpKeyDown(
                              index,
                              e
                            )
                          }
                          inputMode="numeric"
                          maxLength={1}
                          disabled={
                            loading
                          }
                          autoFocus={
                            index ===
                            0
                          }
                          style={{
                            width: 44,
                            height: 52,
                            textAlign:
                              'center',
                            fontFamily:
                              "'JetBrains Mono', monospace",
                            fontSize: 20,
                            fontWeight:
                              700,
                            color:
                              '#10233F',
                            border:
                              '1.5px solid #DDE2EA',
                            borderRadius:
                              10,
                            background:
                              '#FCFBF8',
                          }}
                        />
                      )
                    )}
                  </div>

                  <button
                    onClick={
                      verifyOtp
                    }
                    disabled={
                      loading
                    }
                    className="cp-btn"
                    style={{
                      marginTop: 26,
                      width: '100%',
                      background:
                        '#16325C',
                      color:
                        '#F7F4EE',
                      border: 'none',
                      borderRadius: 10,
                      padding:
                        '13px 0',
                      fontSize: 14.5,
                      fontWeight: 600,
                      cursor:
                        loading
                          ? 'default'
                          : 'pointer',
                      display:
                        'flex',
                      alignItems:
                        'center',
                      justifyContent:
                        'center',
                      gap: 8,
                      opacity:
                        loading
                          ? 0.75
                          : 1,
                    }}
                  >
                    {loading ? (
                      <>
                        <FaSpinner
                          size={14}
                          style={{
                            animation:
                              'rotate 0.8s linear infinite',
                          }}
                        />
                        Verifying
                      </>
                    ) : (
                      <>
                        <FaShieldAlt
                          size={14}
                        />
                        Verify &amp;
                        sign in
                      </>
                    )}
                  </button>

                  {/* RESEND */}

                  <div
                    style={{
                      marginTop: 18,
                      textAlign:
                        'center',
                      fontSize: 13,
                      color:
                        '#697386',
                    }}
                  >
                    {resendIn > 0 ? (
                      <span>
                        Resend code in{' '}
                        {resendIn}s
                      </span>
                    ) : (
                      <button
                        onClick={
                          sendOtp
                        }
                        disabled={
                          loading
                        }
                        className="cp-link"
                        style={{
                          background:
                            'none',
                          border:
                            'none',
                          color:
                            '#16325C',
                          fontWeight:
                            600,
                          cursor:
                            loading
                              ? 'default'
                              : 'pointer',
                          display:
                            'inline-flex',
                          alignItems:
                            'center',
                          gap: 5,
                        }}
                      >
                        <FaSyncAlt
                          size={11}
                        />
                        Resend code
                      </button>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (

            /* =================================================
               VERIFIED
            ================================================= */

            <div
              style={{
                textAlign:
                  'center',
                animation:
                  'stampIn 0.5s ease-out',
              }}
            >
              <FaCheckCircle
                size={44}
                color="#1F7A4D"
                style={{
                  marginBottom: 14,
                }}
              />

              <h2
                style={{
                  fontFamily:
                    "'Fraunces', serif",
                  fontSize: 22,
                  color:
                    '#10233F',
                  margin:
                    '0 0 6px',
                }}
              >
                You're verified
              </h2>

              <p
                style={{
                  color:
                    '#697386',
                  fontSize: 14,
                }}
              >
                Taking you to your
                dashboard…
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;